module.exports = __webpack_public_path__ + "img/im_hero_bg@2x.dde08684.png";